const TRACKING_API_URL = 'claimfileuploaderapi/v1/tracking/'

export { TRACKING_API_URL }
